import * as React from "react"

import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { IUserRole } from "@/dto/user/user-role.dto";
import { Badge } from "@/components/ui/badge";
import { UserRoleEnum } from "@/enums";

interface IProps {
    role: IUserRole;
    onDelete: () => void;
}

function AdminRoleUserTag({ role, onDelete }: IProps) {
    const [deleteState, setDeleteState] = React.useState(false);

    const canDelete = role.roleName !== UserRoleEnum.ATTENDANT;

    const handleClick = () => {
        if (!canDelete) {
          return;
        }
        if (!deleteState) {
            setDeleteState(true);
            setTimeout(() => {
              setDeleteState(false);
            }, 2000);
        } else {
          onDelete();
        }
    }

    return <Tooltip key={role.id}>
        <TooltipTrigger asChild>
          <Badge variant={deleteState ? "destructive" : "secondary"} onClick={handleClick} className={canDelete ? "cursor-pointer" : ""}>
              {deleteState ? "Quitar" : role.roleName}
            </Badge>
        </TooltipTrigger>
        <TooltipContent>
            {role.description}
        </TooltipContent>
    </Tooltip>
}

export { AdminRoleUserTag };
